export const AI_PROPOSAL_SECTION_ROUTES = Object.freeze({
  "gw-ai-propose-datasource": { id: "database-connections" },
  "gw-ai-propose-api-profile": { id: "api-connections" },
  "gw-ai-propose-credential": { id: "api-credentials" },
  "gw-ai-propose-oauth-app": { id: "oauth-apps" },
  "gw-ai-propose-mqtt-broker": { id: "mqtt-brokers" },
  "gw-ai-propose-mqtt-subscription": { id: "mqtt-brokers" },
  "gw-ai-propose-historian-provider": { id: "historian-providers" },
  "gw-ai-propose-user": { id: "user-management" },
  "gw-ai-propose-group": { id: "user-management" },
  "gw-ai-propose-project": { id: "projects-list" },
  "gw-ai-propose-ai-provider": { id: "api-ai-settings" },
  "gw-ai-propose-alarm": { id: "alarms-notifications" },
  "gw-ai-propose-edge-gpio": { id: "plc-runtime-fleet", search: "?view=hosts" },
  "gw-ai-propose-edge-modbus-rtu": { id: "plc-runtime-fleet", search: "?view=hosts" },
  "gw-ai-propose-plc-fleet-rollout": { id: "plc-deployments" },
  "gw-ai-propose-plc-fleet-control": { id: "plc-deployments" },
  "gw-ai-propose-plc-controller-draft-change": { id: "plc-runtime-fleet", search: "?view=controllers" },
  "gw-ai-propose-plc-controller-lifecycle": { id: "plc-runtime-fleet", search: "?view=controllers" },
  "gw-ai-propose-opcua-server-role": { id: "opcua-server", search: "" },
  "gw-ai-propose-edge-modbus-server": { id: "plc-protocol-services", search: "?service=modbus" },
});

export function aiProposalRouteIsActive(route, activeSection, search = "") {
  if (!route || route.id !== activeSection) return false;
	const requestedService = new URLSearchParams(route.search || "").get("service");
	if (requestedService && new URLSearchParams(search).get("service") !== requestedService) return false;
  const requestedView = new URLSearchParams(route.search || "").get("view");
  if (!requestedView) return true;
  return new URLSearchParams(search).get("view") === requestedView;
}
